import React from "react";
import styled from "styled-components";

const SendMail = ({ meta, value }) => {
  return (
    <Container>
      <MainContainer style={{ width: "100%" }}>
        <EmailWrapper>
          <tbody>
            <EmailRow>
              <EmailCell>
                <EmailLogo
                  src={
                    "https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660799066-ffa8d6e8-80b2-4bd4-a917-e3f6726cfe17/MulticallLogo.png"
                  }
                  alt="Left Logo"
                />
              </EmailCell>
              <EmailCell alignRight>
                <EmailLogo
                  src={
                    "https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660895889-69aaf6ce-c72d-4f41-a143-980ec5b935be/Asset%203%404x-8.png"
                  }
                  alt="Right Logo"
                />
              </EmailCell>
            </EmailRow>
          </tbody>
        </EmailWrapper>
        <Row>
          <Header>Event Confirmation</Header>
        </Row>
        <HeaderContent>
          <p style={{ marginBottom: "10px" }}>
            <BoldText>{meta?.eventTitle}</BoldText> on {meta?.eventDate} at{" "}
            {meta?.eventTime}
          </p>
          <p>{meta?.coordinatorInfo?.coordinatorName},</p>
          <p>
            Thank you for choosing MultiCall. Please find the confirmation for
            the AGM below:
          </p>
        </HeaderContent>
        <Row>
          <Section green>Schedule</Section>
          <Section green>Coordinator</Section>
        </Row>
        <Content>
          <Column>
            <p>
              <BoldText>Event No:</BoldText> {meta?.eventId}
            </p>
            <p>
              <BoldText>Company Name:</BoldText> {meta?.orgName}
            </p>
            <p>
              <BoldText>Date:</BoldText> {meta?.eventDate} at {meta?.eventTime}{" "}
              for {meta?.eventDuration} hours
            </p>
            <p>
              <BoldText>Type:</BoldText> AGM
            </p>
          </Column>
          <Column>
            <p>
              <BoldText>Name:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorName
                ? meta?.coordinatorInfo?.coordinatorName
                : "-"}
            </p>
            <p>
              <BoldText>Phone:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorphone
                ? meta?.coordinatorInfo?.coordinatorphone
                : "-"}
            </p>
            <p>
              <BoldText>Email ID:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorEmail
                ? meta?.coordinatorInfo?.coordinatorEmail
                : "-"}
            </p>
            <p>
              <BoldText>Location:</BoldText>{" "}
              {meta?.coordinatorInfo?.coordinatorLocation
                ? meta?.coordinatorInfo?.coordinatorLocation
                : "-"}
            </p>
          </Column>
        </Content>
        <Row>
          <SectionTitle green>Important Links</SectionTitle>
        </Row>
        <TwoColumnSection>
          <Column>
            {meta?.advanceOptions?.micrositePrefix ? (
              <LinksContainer>
                <BoldText>Microsite Link:</BoldText>{" "}
                <StyledLink
                  href={meta?.advanceOptions?.micrositePrefix}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {meta?.advanceOptions?.micrositePrefix}
                </StyledLink>
              </LinksContainer>
            ) : (
              ""
            )}
            {meta?.eventUrl ? (
              <LinksContainer>
                <BoldText>Participant Link:</BoldText>{" "}
                <StyledLink
                  href={meta?.eventUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {meta?.eventUrl}
                </StyledLink>
              </LinksContainer>
            ) : (
              ""
            )}
          </Column>
          <Column>
            {meta?.eventTemplate === "AGM" ? (
              meta?.galleryView?.galleryViewUrl ? (
                <LinksContainer>
                  <BoldText>Gallery View Link:</BoldText>{" "}
                  <StyledLink
                    href={meta?.galleryView?.galleryViewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {meta?.galleryView?.galleryViewUrl}
                  </StyledLink>
                </LinksContainer>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </Column>
        </TwoColumnSection>
        <Row>
          <Section green>Value Added Services</Section>
          <Section green>Reminders</Section>
        </Row>
        <TwoColumnSection>
          <Column>
            {meta?.livePageSettings?.textQuestion && (
              <p>
                <BoldText>Text Question: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.videoQuestion && (
              <p>
                <BoldText>Video Question: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.livePoll && (
              <p>
                <BoldText>Live Polls: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.liveTickers && (
              <p>
                <BoldText>Live Ticker: </BoldText> Yes
              </p>
            )}
            {meta?.livePageSettings?.playbackRequired && (
              <p>
                <BoldText>Playback Info: </BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Custom Microsite: </BoldText>
              {meta?.advanceOptions?.micrositePrefix ? "Yes" : "No"}
            </p>
            <p>
              <BoldText>Social Media: </BoldText> MultiCall, YouTube, Facebook,
              Instagram, LinkedIn, Twitter
            </p>
          </Column>
          <Column>
            {meta?.reminders?.sms && (
              <p>
                <BoldText>SMS: </BoldText> Yes
              </p>
            )}
            {meta?.reminders?.email && (
              <p>
                <BoldText>Email: </BoldText> Yes
              </p>
            )}
            {meta?.reminders?.whatsApp && (
              <p>
                <BoldText>WhatsApp: </BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Voice Drop: </BoldText>{" "}
              {meta?.reminders?.voiceDrop ? "Yes" : "No"}
            </p>
            <p>
              <BoldText>Personal Invitation: </BoldText>{" "}
              {meta?.reminders?.individual ? "Yes" : "No"}
            </p>
          </Column>
        </TwoColumnSection>
        <Row>
          <SectionTitle green>Speaker Joining Information </SectionTitle>
        </Row>
        <SpeakersContainer>
          {meta?.speakerSettings?.length &&
          meta?.speakerSettings[0]?.speakerName
            ? meta.speakerSettings.map((speaker, index) => (
                <SpeakerCard
                  style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}
                  key={index}
                >
                  <SpeakerInfo>
                    <p>
                      <strong>Speaker Name:</strong>{" "}
                      {speaker.speakerName || "N/A"}
                    </p>
                    <InputContainer>
                      <strong>Video Meeting Link:</strong>
                      <span style={{ marginLeft: "5px" }}>
                        {value[index] || "-"}
                      </span>
                    </InputContainer>
                  </SpeakerInfo>
                </SpeakerCard>
              ))
            : null}
        </SpeakersContainer>
        <Row>
          <SectionTitle green>
            Video Participant Joining Information
          </SectionTitle>
        </Row>
        <Row>
          <SectionTitle green>Event Configuration</SectionTitle>
        </Row>

        <TwoColumnSection>
          <Column>
            {meta?.eventSettings?.enableRegistration && (
              <p>
                <BoldText>Registrations:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.commonPassword && (
              <p>
                <BoldText>Common Password:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.enableLogins && (
              <p>
                <BoldText>Logins Required:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.singleUserSingleEntry && (
              <p>
                <BoldText>Single User Single Entry:</BoldText> Yes
              </p>
            )}
            {meta?.speakerSection?.speakersRequired && (
              <p>
                <BoldText>Speakers Section:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Speakers Visibility:</BoldText>{" "}
              {meta?.speakerSection?.speakersVisibility || "N/A"}
            </p>
          </Column>

          <Column>
            {meta?.eventSettings?.passwordRequired && (
              <p>
                <BoldText>Password Required:</BoldText> Yes
              </p>
            )}
            {meta?.eventSettings?.sendEmailDuringRegistration && (
              <p>
                <BoldText>Send Emails During Registration:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Pre-validate Registrations:</BoldText>{" "}
              {meta?.preValidateUsers?.preValidateLabel || "N/A"}
            </p>
            {meta?.resourceSection?.resourcesRequired && (
              <p>
                <BoldText>Resources Section:</BoldText> Yes
              </p>
            )}
            <p>
              <BoldText>Content Format:</BoldText>{" "}
              {meta?.livePageSettings?.contentFormat || "-"}
            </p>
          </Column>
        </TwoColumnSection>
        <Row>
          <SectionTitle green>Operator Script</SectionTitle>
        </Row>
        <Content>
          <Column>
            <Text>Regards</Text>
            <Text>
              <strong>{meta?.eventManageName || "Event Manager"}</strong>
            </Text>
            <Text>
              <StrongBlue>C3ware Multi</StrongBlue>{" "}
              <StrongGreen>Call Technologies Pvt Ltd</StrongGreen>
            </Text>
            <Text>
              <StrongBlue>+91 44 66776600</StrongBlue>
              <Separator>|</Separator>
              <StrongGreen>+91 44 22540231</StrongGreen>
            </Text>
            <Text>
              <StrongBlue>events@multicall.in</StrongBlue>
              <Separator>|</Separator>
              <StrongGreen>customercare@dsnl.in</StrongGreen>
            </Text>
            <Image
              src={
                "https://justact.s3.ap-south-1.amazonaws.com/Justact/1740660799066-ffa8d6e8-80b2-4bd4-a917-e3f6726cfe17/MulticallLogo.png"
              }
              alt="Company Logo"
            />
          </Column>
        </Content>
      </MainContainer>
    </Container>
  );
};

export default SendMail;

const EmailWrapper = styled.table`
  width: 100%;
  border-collapse: collapse;
  padding: 10px;
`;

const EmailRow = styled.tr``;

const EmailCell = styled.td`
  width: 50%;
  padding: 10px;
  text-align: ${({ alignRight }) => (alignRight ? "right" : "left")};

  @media (max-width: 600px) {
    display: block;
    width: 100%;
    text-align: center;
  }
`;

const EmailLogo = styled.img`
  max-width: 150px;
  height: auto;
`;

const Container = styled.div`
  font-family: "Poppins", sans-serif;
  padding: 20px;
`;

const Header = styled.div`
  background-color: #005aa7;
  width: 100%;
  color: white;
  text-align: center;
  padding: 10px;
  font-size: 22px;
  font-weight: bold;
`;

const Section = styled.div`
  width: 100%;
  background-color: ${(props) => (props.green ? "#4CAF50" : "")};
  color: ${(props) => (props.green ? "white" : "black")};
  padding: 10px;
  font-weight: ${(props) => (props.green ? "bold" : "normal")};
  margin-top: 10px;
`;

const SectionTitle = styled.div`
  width: 100%;
  background-color: ${(props) => (props.green ? "#4CAF50" : "")};
  color: ${(props) => (props.green ? "white" : "black")};
  padding: 10px;
  font-weight: ${(props) => (props.green ? "bold" : "normal")};
  margin-top: 10px;
  text-align: center;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  // background: white;
  padding: 15px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Column = styled.div`
  width: 50%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const BoldText = styled.span`
  font-weight: bold;
`;

const TwoColumnSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 15px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Text = styled.p`
  margin: 5px 0;
`;

const StrongBlue = styled.strong`
  color: #00aeef;
`;

const StrongGreen = styled.strong`
  color: #5cb338;
`;

const Separator = styled.span`
  margin: 0 8px;
  color: #333;
`;

const Image = styled.img`
  width: 174px;
  height: 60px;
  margin-top: 10px;
`;

const SpeakersContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  font-family: "Poppins", sans-serif;
`;

const SpeakerCard = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 8px;
`;

const SpeakerInfo = styled.div`
  flex: 1;
  p {
    margin: 0;
    font-size: 14px;
  }
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const StyledLink = styled.a`
  color: #007bff;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 3px;
  &:hover {
    text-decoration: underline;
  }
`;

const Row = styled.div`
  display: flex;
  margin-bottom: 5px;
  width: 100%;
`;

const MainContainer = styled.div`
  width: 100%;
  border-radius: 10px;
`;

const LinksContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

const HeaderContent = styled.div`
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px;
  border-radius: 5px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
